export default __webpack_public_path__ + "static/media/1156_trätrall_acacia.0955015f.jpg";